export class Controller {

    /** @ngInject */
    constructor($state, $stateParams, $rootScope, $window, LicenseTierDetails, LicenseManagementService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.LicenseTierDetails = LicenseTierDetails;
        this.LicenseManagementService = LicenseManagementService;
    }

    $onInit() {
        this.licenseInfo = this.licenseDetails.licenseInfo;
        this.selectedTier = this.licenseTiers[0];
        this.selectedPrice = this.selectedTier.prices[0];
        this.seats = 10;

        if(this.licenseInfo.licenseStatus == 'LICENSED' || this.licenseDetails.waitingActivity) {
            this.$state.go('company.license-management.current-plan');
        }
    }

    viewTierDetails() {
        this.LicenseTierDetails(this.licenseTiers);
    }

    selectedTierChanged() {
        this.selectedPrice = this.selectedTier.prices[0];
    }

    processBillingInterval(interval) {
        if(interval == 1) {
            return 'Monthly'
        } else if(interval == 12) {
            return '1 Year'
        } else if(interval == 24) {
            return '2 Years'
        } else if(interval == 36) {
            return '3 Years'
        }
    }
    
    getTotalPriceValue() {
        if(this.selectedTier && this.selectedPrice && this.seats > 0) {
            return this.selectedPrice.price * this.seats + ' ' + this.selectedPrice.currency; 
        } else {
            return 'NaN'
        }
    }

    startSubscription() {
        let purchaseDTO = {
            tierId: this.selectedTier.tierId,
            priceId: this.selectedPrice.priceId,
            userSeats: this.seats,
            promotionCode: this.promotionCode,
            email: this.email
        }
        this.LicenseManagementService.licensePurchase(this.$stateParams.companyId, purchaseDTO)
        .then(result => {
            if(result.checkoutError) {
                this.Alert('danger', result.checkoutError);
            } else {
                if(result.sessionUrl) {
                    this.sessionUrl = result.sessionUrl;
                    this.$window.open(result.sessionUrl, '_blank');
                }
                this.$state.go('^', {}, {reload: '^'})
            }
        })
    }

    subscribeButtonDisabled() {
        return !(this.selectedTier && this.selectedPrice && this.seats > 0 && this.$rootScope.emailPattern.test(this.email));
    }

}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/purchase-license/purchase-license.controller.js